import { Box, Button, Flex, Grid, Heading, Icon, Input, Text } from '@chakra-ui/react'
import { Image } from '@/components/HOC/Image'
import { AppModals, useAppModal } from '@/context/ModalProvider'
import { useTranslation } from 'next-i18next/pages'

export const MainBanner = () => {
  return (
    <>
      <Box mb={{ base: 4, lg: 6, xl: 10 }}>
        <Grid gap={{ base: 2, lg: 4, xl: 6 }} gridTemplateColumns={{ base: '1fr', md: '828fr 382fr' }}>
          <Flex
            aspectRatio={{ base: '360 / 219', md: '828 / 324' }}
            w={'full'}
            rounded={'3xl'}
            overflow={'hidden'}
            bg={'ninja.500'}
            flexDir={'column'}
            h={'full'}
            justifyContent={'center'}
            pos={'relative'}
          >
            <BannerProvider />
          </Flex>
          <SubBannerPromoCode />
        </Grid>
      </Box>
    </>
  )
}

// import SubBannerImageText from '@/public/assets/images/home/sub-banner-text.jpg'
// const SubBannerText = () => {
//   return (
//     <Flex
//       flexShrink={0}
//       pos={'relative'}
//       aspectRatio={'382 / 324'}
//       p={6}
//       rounded={'3xl'}
//       bg={'ninja.500'}
//       flexDir={'column'}
//       justifyContent={'end'}
//       overflow={'hidden'}
//     >
//       <Image src={SubBannerImageText} alt="" pos={'absolute'} inset={0} />
//       <Box zIndex={10} maxW={'200px'}>
//         <Heading fontSize={'clamp(0px, 2.08vw, 32px)'} mb={1}>
//           Built on
//           <br /> blockchain
//         </Heading>
//         <Text
//           bgBlendMode={'overlay'}
//           bgGradient={`linear-gradient(279deg, #BFB9FF -3.89%, #9D7AFF 27.71%, #CAA1FF 62.86%, #DCCBFF 102.07%)`}
//           backgroundClip={'text'}
//           __css={{
//             '-webkit-text-fill-color': 'transparent',
//           }}
//           lineHeight={1.2}
//           fontSize={'clamp(12px, 1.3vw, 20px)'}
//           fontWeight={700}
//         >
//           Provides
//           <br /> transparency
//           <br /> and{'\u00A0'}confidence.
//         </Text>
//       </Box>
//     </Flex>
//   )
// }

// import Link from 'next/link'
import SubBannerImage from '@/public/assets/images/home/sub-banner.jpg'
import ArrowIcon from '@/public/assets/icons/arrow.svg'
import { usePromoCodeForm } from '@/components/molecules/PromoCode/PromoCode'
import { useEffect } from 'react'
import { BannerProvider } from '../Slider/Slider'

const SubBannerPromoCode = () => {
  const { error, handleSubmit, isPending, reward, setCode, code } = usePromoCodeForm()
  const modal = useAppModal()
  const { t } = useTranslation()

  useEffect(() => {
    if (!!reward) {
      modal.openModalNew(AppModals.PromoCodeModal, { initialReward: reward })
    }
  }, [reward])

  return (
    <Flex
      flexShrink={0}
      pos={'relative'}
      aspectRatio={{ base: '360 / 148', md: '382 / 324' }}
      p={{ base: 0, md: 4 }}
      rounded={'3xl'}
      bg={'ninja.500'}
      flexDir={'column'}
      justifyContent={'center'}
      overflow={'hidden'}
    >
      <Image src={SubBannerImage} alt="" pos={'absolute'} inset={0} />
      <Box zIndex={10}>
        <Heading
          mb={'clamp(0px, 1.3vw, 20px)'}
          textAlign={'center'}
          lineHeight={{ base: 1.1, sm: 1.2 }}
          fontSize={{ base: 'clamp(20px, 4.16vw, 32px)', md: 'clamp(0px, 2.0vw, 32px)' }}
        >
          {t('Home.activate-promo-code-get-bonus')}
        </Heading>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            handleSubmit()
          }}
        >
          <Flex
            border={'1px solid'}
            borderColor={!error ? 'transparent' : 'brand.error'}
            alignItems={'center'}
            bg={'ninja.500'}
            p={{ md: 0.5, lg: 1 }}
            rounded={'xl'}
            maxW={{ base: '180px', sm: '240px', md: '180px', lg: '220px', xl: '260px' }}
            mx={'auto'}
          >
            <Input
              value={code}
              onChange={(e) => setCode(e.target.value)}
              mt={'px'}
              placeholder={t('common.enter-your-code')}
              _placeholder={{
                color: 'ninja.200',
                fontSize: { md: 'xs', lg: 'sm' },
                fontWeight: 700,
              }}
              fontWeight={700}
              fontSize={{ base: 'xs', sm: 'sm', md: 'xs', lg: 'sm' }}
              px={{ base: 2, sm: 4, md: 2, lg: 4 }}
              variant={'unstyled'}
              isDisabled={isPending}
            />
            <Button
              isLoading={isPending}
              type="submit"
              flexShrink={0}
              rounded={'xl'}
              px={0}
              h={{ base: '32px', sm: '40px', md: '32px', lg: '40px', xl: '46px' }}
              w={{ base: '32px', sm: '40px', md: '32px', lg: '40px', xl: '46px' }}
            >
              <Icon
                transform={'rotate(180deg)'}
                as={ArrowIcon}
                w={{ base: 4, sm: 6, md: 4, lg: 6 }}
                h={{ base: 4, sm: 6, md: 4, lg: 6 }}
              />
            </Button>
          </Flex>
        </form>

        {!!error && (
          <Flex justifyContent={'center'}>
            <Text
              mx={'auto'}
              minH={'22px'}
              textAlign={'center'}
              maxW={{ base: '180px', sm: '240px', md: '180px', lg: '220px', xl: '260px' }}
              mt={1}
              pt={0.5}
              px={1}
              lineHeight={1.1}
              py={1}
              color={'brand.error'}
              fontWeight={700}
              fontSize={{ base: '10px', sm: 'xs', md: '10px', xl: 'xs' }}
              bg={!error ? 'transparent' : 'rgb(40 39 89 / 60%)'}
              rounded={'md'}
            >
              {error}
            </Text>
          </Flex>
        )}
      </Box>
    </Flex>
  )
}
